import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

function ResaleTicketsButton({
    onResaleClick,
    buttonText,
    buttonColor
}) {
    return (
        <Fragment>
            <button
                className={`${buttonColor}-button`}
                onClick={onResaleClick}
            >{buttonText}
            </button>
        </Fragment>
    );
}

ResaleTicketsButton.propTypes = {
    onResaleClick: PropTypes.func.isRequired,
    buttonText: PropTypes.string.isRequired,
    buttonColor: PropTypes.string.isRequired,
};

export default ResaleTicketsButton;
